module.exports = __webpack_public_path__ + "img/intel.ef49e89e.svg";